import { EmailDesign } from "@/stores/emailBuilderStore";

export const DefaultAcknowledgementEmail = (design: EmailDesign) => {
    return {
        page: {
            body: {
                container: {
                    style: {
                        "background-color": "#ffffff",
                    },
                },
                content: {
                    computedStyle: {
                        align: "center",
                        linkColor: "#0015ADE8",
                        messageBackgroundColor: "#ffffff",
                        messageWidth: "600px",
                    },
                    style: {
                        color: "#000000",
                        "font-family":
                            "'Helvetica Neue', Helvetica, Arial, sans-serif",
                    },
                },
                webFonts: [],
            },
            description: "",
            rows: [
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnAmp: false,
                                            hideContentOnDesktop: false,
                                            hideContentOnHtml: false,
                                            hideContentOnMobile: false,
                                        },
                                        html: {
                                            html: `<img src="${design.logoUrl}" alt="Organization Logo" style="width:25%;" />`,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-html",
                                    uuid: "a9e31d6e-73ab-4713-a298-dd1b6a580b06",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "35px",
                            },
                            uuid: "28468b07-16bd-4e44-8f1e-1129ca379fc5",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "0141885f-fcd4-45b7-bd05-60adcaf9b532",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "25px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="font-size:14px;line-height:16px;word-break:break-word;" data-mce-style="font-size:14px;line-height:16px;word-break:break-word;"><span style="font-size:26px;line-height:31px;" data-mce-style="font-size:26px;line-height:31px;">A gift was made <code spellcheck="false" data-bee-type="mergetag" data-bee-code="" data-bee-name="TributeType">{{TributeType}} </code><code spellcheck="false" data-bee-type="mergetag" data-bee-code="" data-bee-name="TributeFirstName">{{TributeFirstName}} </code><code spellcheck="false" data-bee-type="mergetag" data-bee-code="" data-bee-name="TributeLastName">{{TributeLastName}}</code>&nbsp;</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "a377a2af-53e5-463e-b091-901bf99280b6",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "40px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "0eae70f5-b136-4e81-b936-4c22cc7b8e23",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:21px;font-family:inherit;" data-mce-style="font-size:14px;line-height:21px;font-family:inherit;"><p style="font-size:14px;line-height:21px;word-break:break-word;" data-mce-style="font-size:14px;line-height:21px;word-break:break-word;"><span style="font-size:16px;line-height:24px;" data-mce-style="font-size:16px;line-height:24px;">{{DonorFirstName}} {{DonorLastName}} made a generous donation to our organization in {{TributeFirstName}}&#39;s name.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "2d0234da-873a-4cd7-a096-d28622ace83c",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "20px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "10px",
                            },
                            uuid: "455c453d-6769-4a2f-b50f-a31ec94b7fc8",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "60a696ab-a0d5-4a45-a8dd-3eebad4a4fc4",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:16px;font-family:inherit;" data-mce-style="font-size:14px;line-height:16px;font-family:inherit;"><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13241" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Organization Name</strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13260" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{OrganizationName}}</span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13260" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;">&nbsp;</p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13282" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">Gift Date </strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13294" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{GiftDate}}</span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13294" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;">&nbsp;</p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13308" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;"><strong data-renderer-mark="true">&nbsp;Gift Message</strong></span></p><p style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;" data-renderer-start-pos="13338" data-mce-style="line-height:18px;word-break:break-word;font-size:15px;text-align:center;"><span style="font-size:15px;line-height:18px;" data-mce-style="font-size:15px;line-height:18px;">{{AcknowledgementMessage}}</span></p></div>',
                                            style: {
                                                color: "#6f6f6f",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "3490e6bd-03c6-4c33-b1f9-43cc5942816c",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "30px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "25px",
                            },
                            uuid: "53cf2524-55ce-40f7-a85d-a6e36fa8eaf0",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#fafafa",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "20px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "d5023376-f854-4e0b-a1df-13d8a3e0feca",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid transparent",
                                                height: "1px",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "30px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "30px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "d7aaab69-a2ca-4f3a-80e7-8ae3c7670b9b",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px",
                            },
                            uuid: "b7169a1e-cd95-47e9-a353-e19e9fe2f9c4",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "#ffffff",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "590cc147-7b1c-49e3-8a26-ac353bc9f6ef",
                },
            ],
            template: {
                version: "2.0.0",
            },
            title: "",
        },
        comments: {},
    };
};
